(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-variant-descriptions"] && !Shopify.designMode) return;
  try {
    document.addEventListener('page:loaded', function() {
        const variantDescriptions = document.querySelectorAll('.variant-description');
        if (!variantDescriptions || !variantDescriptions.length) return;

        document.addEventListener('variant:change', function(evt) {
            const variantId = evt.detail.variant.id;
 
            variantDescriptions.forEach(variantDescription => {
                const variantDescriptionId = variantDescription.getAttribute('variant-id');
                variantDescription.setAttribute('data-active', Number(variantDescriptionId) === variantId ? 'true' : 'false');
            });
        });
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-information-modal"] && !Shopify.designMode) return;
  try {
    document.addEventListener('page:loaded', function() {
      new theme.Modals('VariantInformationModal', 'variant-information-modal');
    });
  } catch(e) { console.error(e); }
})();

})();
